import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Coon Rapids",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Coon Rapids Minnesota cityscape with suburban neighborhoods along the Mississippi River, Coon Rapids Dam Regional Park, retail corridors along Highway 10, residential streets with mature trees, north metro Twin Cities area, warm golden hour lighting, professional cityscape photography, no readable text or signs",
  heroImageSeq: "coon-rapids-mn-hero-2026",
  heroDescription:
    "Business trip to Europe in two weeks? Family vacation to Mexico and your passport just expired? Need a first-time passport for a new job? We help Coon Rapids residents — from Riverdale area families to north metro commuters and Anoka County professionals — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "45.1199; -93.2877",
  geoPlacename: "Coon Rapids, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/coon-rapids/",
  localAreaTitle: "Serving Coon Rapids & North Metro Anoka County",
  localAreaText: [
    "Coon Rapids, Minnesota is the largest city in Anoka County and a major suburb in the north metro Twin Cities area. Located along the Mississippi River, the city has a distinctive blend of suburban comfort, natural beauty, and commercial energy. The Coon Rapids Dam Regional Park is one of the most popular outdoor destinations in the metro area, drawing visitors from across the region for hiking, fishing, and river views.",
    "The city's commercial corridors along Highway 10 and University Avenue have developed into major retail and business centers, creating a prosperous community where international travel is common. Coon Rapids residents work in a variety of industries — healthcare, retail, manufacturing, and professional services — and many travel for business, conferences, and client meetings.",
    "Coon Rapids' location at the northern edge of the metro area makes it a gateway to the northern Minnesota lake country. Many residents travel north to Brainerd, the Iron Range, and the Boundary Waters for recreation, and also fly south to Mexico and the Caribbean for winter escapes. The city's strong family orientation means many residents are raising children while maintaining active travel schedules.",
    "The residential neighborhoods of Coon Rapids are diverse, from established communities near the river to newer developments in the city's north and east. The Riverdale shopping district and the commercial areas along Highway 10 provide the amenities of a major city while maintaining a suburban feel. Families in these communities are active travelers — spring break trips, summer vacations, and visits to relatives abroad are all common.",
  ],
  nearbyCities: [
    { name: "Coon Rapids", zips: "55433, 55448" },
    { name: "Blaine", zips: "55434, 55449" },
    { name: "Anoka", zips: "55303" },
    { name: "Fridley", zips: "55421, 55432" },
    { name: "Brooklyn Park", zips: "55428, 55429, 55443, 55444, 55445" },
    { name: "Ramsey", zips: "55303" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your home or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping from Coon Rapids to send your documents directly to us.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Coon Rapids & North Metro Coverage",
  serviceAreaDescription: "Serving Anoka County and north metro communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Coon Rapids, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Coon Rapids can take 2–6 months. For families with vacation plans and professionals with business trips, that timeline is not viable.",
    },
    {
      q: "Can families get expedited passports before a vacation?",
      a: "Absolutely. Coon Rapids families are one of our most common client types. Many families book trips and discover passport issues close to departure. We regularly process expedited renewals and child passports for families on compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "What if my passport expires before a business trip?",
      a: "Coon Rapids professionals frequently travel for business with short notice. If your passport is expiring or expired, we can expedite your renewal so you do not miss critical meetings. Most business trips are scheduled 2–3 weeks out.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Coon Rapids travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Coon Rapids. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the north metro.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "David M.",
      location: "Coon Rapids, MN",
      rating: 5,
      text: "I received a last-minute assignment to a client meeting in Toronto with nine days notice. My passport was within two months of expiration. Fast Passport Center processed my renewal in four business days. I made the meeting and it went perfectly. Their document review caught a photo issue that would have caused a delay.",
      service: "Passport Renewal",
    },
    {
      name: "The Johnson Family",
      location: "Coon Rapids, MN",
      rating: 5,
      text: "We planned a family trip to Mexico and discovered our son's passport had expired two weeks before departure. Fast Passport Center processed his child passport in five business days. We made our trip and created wonderful memories. Thank you for the professional service.",
      service: "Child Passport",
    },
    {
      name: "Lisa R.",
      location: "Coon Rapids, MN",
      rating: 5,
      text: "I was invited to a conference in Barcelona with three weeks notice. My passport was within two months of expiration. Fast Passport Center had my renewal processed in five business days. I attended the conference and made valuable connections. Exceptional service.",
      service: "Emergency Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Blaine", href: "/blaine" },
    { name: "Brooklyn Park", href: "/brooklyn-park" },
    { name: "Anoka", href: "/minnesota" },
    { name: "Fridley", href: "/minnesota" },
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "Maple Grove", href: "/maple-grove" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Coon Rapids",
  introDescription: "Fast, reliable passport processing for Coon Rapids and north metro Anoka County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Coon Rapids and north metro resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Coon Rapids Post Office",
      address: "2929 Anoka Blvd, Coon Rapids, MN 55433",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(763) 421-1810",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Coon Rapids and Anoka County.",
    },
    {
      name: "Blaine Post Office",
      address: "2555 Hwy 10 NE, Blaine, MN 55449",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(763) 780-8771",
      notes: "Convenient for Blaine and north Anoka County residents. Passport photos available. Call ahead for appointment.",
    },
    {
      name: "Anoka Post Office",
      address: "2168 7th Ave, Anoka, MN 55303",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(763) 421-4478",
      notes: "Serves Anoka and western Anoka County residents. Call ahead for appointment availability.",
    },
    {
      name: "Brooklyn Park Post Office",
      address: "5000 85th Ave N, Brooklyn Park, MN 55443",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(763) 424-5673",
      notes: "Serves Brooklyn Park and Hennepin County residents near the north metro.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Coon Rapids", address: "11750 University Ave NE, Coon Rapids, MN 55448", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Coon Rapids", address: "12001 Riverdale Blvd, Coon Rapids, MN 55433", hours: "Call for hours" },
    { name: "The UPS Store — Coon Rapids", address: "3430 129th Ave NW, Coon Rapids, MN 55448", hours: "Call for hours" },
    { name: "Walgreens — Blaine", address: "10965 University Ave NE, Blaine, MN 55434", hours: "Call for hours" },
    { name: "CVS Pharmacy — Anoka", address: "400 E Main St, Anoka, MN 55303", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Coon Rapids", address: "12920 Riverdale Blvd, Coon Rapids, MN 55448", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — Coon Rapids",
      address: "Coon Rapids area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Anoka County Service Center",
      address: "Anoka, MN 55303",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Anoka County services. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 25 miles from Coon Rapids — 30 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary commercial airport for Coon Rapids residents. Direct international flights to Europe, Asia, and Latin America. The north metro location provides excellent access via Highway 10 or I-35W.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "Rochester, MN — about 95 miles south",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Secondary option for southern Minnesota travelers. Seasonal international charters and domestic connections.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "MSP Airport Proximity",
      subtitle: "Only 30 minutes from Coon Rapids — excellent access for international travel",
      content:
        "Coon Rapids' location in the north metro provides excellent access to MSP Airport via Highway 10 or I-35W. This proximity is a major advantage for the area's frequent international travelers. With nonstop service to Amsterdam, London, Paris, Tokyo, and Reykjavik, many residents connect directly to Europe and Asia.",
      tip: "Check your passport expiration before booking MSP international connections. Most countries require six months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "North Metro Family Travel",
      subtitle: "Active families with travel plans throughout the year",
      content:
        "Coon Rapids families are among the most active travelers in the north metro. Spring break trips, summer vacations, and holiday visits to relatives abroad are all common. The area's proximity to MSP makes international travel particularly convenient for families.",
      tip: "Check every family member's passport at the start of the school year. Children's passports expire in 5 years, not 10. Plan renewals 6 months before any planned travel.",
      icon: "ri-parent-line",
    },
    {
      title: "Coon Rapids Dam & Outdoor Recreation",
      subtitle: "Nature and outdoor enthusiasts with travel interests",
      content:
        "The Coon Rapids Dam Regional Park is a major destination for outdoor enthusiasts in the metro area. These residents often combine their love of nature with international travel — hiking trips to New Zealand, eco-tours in Costa Rica, and camping in Canada. Their travel is frequently seasonal and planned around outdoor activities.",
      tip: "Outdoor travelers should check passport expiration before booking international eco-tours or hiking trips. Many adventure travel packages require 6 months validity.",
      icon: "ri-treasure-map-line",
    },
    {
      title: "North Metro Business Travel",
      subtitle: "Professionals with international clients and partnerships",
      content:
        "Coon Rapids' business community includes healthcare, retail, manufacturing, and professional services companies with international clients. These professionals often travel for business development, client meetings, and trade shows. Business travel frequently has 2–3 weeks notice.",
      tip: "North metro professionals should check passport expiration quarterly. Set calendar reminders. Business travel often has unpredictable lead times.",
      icon: "ri-briefcase-4-line",
    },
  ],
  destinations: [
    {
      name: "Mexico",
      context: "Cancun, Puerto Vallarta, and Cabo for spring break and family vacations",
      urgency: "Spring break trips and resort packages are often booked 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises, all-inclusive resorts, and island hopping",
      urgency: "Cruise departures and resort packages are often booked 3–6 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Toronto, Vancouver, and weekend getaways",
      urgency: "Summer travel and weekend trips peak May through September",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London business meetings and conferences",
      urgency: "Business and conference schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Frankfurt, Munich, and Berlin for business and conferences",
      urgency: "Conference and event schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Costa Rica",
      context: "Eco-tours, adventure travel, and family vacations",
      urgency: "Adventure travel packages are often booked 3–6 weeks out",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "45%",
      label: "of Coon Rapids expedited requests are family travel discovered within 3 weeks of departure",
    },
    {
      stat: "2–4 Weeks",
      label: "average notice Coon Rapids travelers have before a planned international trip",
    },
    {
      stat: "Mar–Aug",
      label: "peak season when spring break, summer vacations, and outdoor travel coincide",
    },
    {
      stat: "48 Hours",
      label: "shortest emergency turnaround we have accommodated for a Coon Rapids professional",
    },
  ],
  vitalRecords: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Minnesota Department of Health Vital Records. Online, mail, or in-person options available for Anoka County births.",
      url: "https://www.health.state.mn.us/people/vitalrecords/"
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the Minnesota Department of Health Vital Records. Required for estate, legal, and survivor benefit matters.",
      url: "https://www.health.state.mn.us/people/vitalrecords/"
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage records from Anoka County Vital Records. Required for name change passport applications. Serving Coon Rapids and all Anoka County communities.",
      url: "https://www.anokacountymn.gov/"
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Anoka County District Court. Required for name change passport corrections and legal documentation.",
      url: "https://www.mncourts.gov/"
    }
  ],
};

export default function CoonRapidsPage() {
  return <CityPage data={data} />;
}